import { useState } from 'react';
import { moldLabelService } from '../services/api';

export const useMoldQRCode = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadMoldQRCode = async (moldId: number | string) => {
    setIsLoading(true);
    setError(null);
    
    try {
      const numericMoldId = typeof moldId === 'string' ? parseInt(moldId) : moldId;
      
      if (!numericMoldId || isNaN(numericMoldId)) {
        throw new Error('รหัสแม่พิมพ์ไม่ถูกต้อง');
      }

      const response = await moldLabelService.downloadMoldLabels({ 
        moldIds: [numericMoldId] 
      });
      
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      
      // Clean up the URL after a delay to prevent memory leaks
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
      
    } catch (err: any) {
      setError('เกิดข้อผิดพลาดในการดาวน์โหลด QR Code กรุณาลองใหม่อีกครั้ง');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const clearError = () => setError(null);

  return {
    downloadMoldQRCode,
    isLoading,
    error,
    clearError
  };
};
